const LoadingOverlay: React.FC = () => {
  return (
    <div className="raul-page-loader-wrapper">
      <div className="raul-page-loader" />
    </div>
  );
};

export default LoadingOverlay;
